/* IZU Paros — shared sheet component: a full-height bottom sheet on mobile, a right-hand drawer from 990px.
   Markup: a trigger with data-sheet-open="<id>" + aria-controls, and <div class="sheet" id="<id>" data-sheet hidden>
   containing .sheet__scrim[data-sheet-close] and .sheet__panel[data-sheet-panel] (optional [data-sheet-drag] header).
   Closes on the close button, scrim tap, Escape or a swipe down; focus is trapped while open and returned after. */
(() => {
  if (window.IZUSheet) return;
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const FOCUSABLE = 'a[href], summary, button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  // ---------- Open / close ----------
  let openSheet = null, lastTrigger = null;

  function open(sheet, trigger) {
    if (openSheet) close(openSheet, false);
    lastTrigger = trigger || null;
    sheet.hidden = false;
    document.documentElement.classList.add("is-sheet-open");
    trigger?.setAttribute("aria-expanded", "true");
    void sheet.offsetHeight; // commit the closed position first so the slide-in transition runs
    sheet.classList.add("is-open");
    openSheet = sheet;
    const panel = sheet.querySelector("[data-sheet-panel]");
    const first = panel.querySelector(".sheet__body")?.querySelector(FOCUSABLE) || panel.querySelector(FOCUSABLE);
    setTimeout(() => first?.focus({ preventScroll: true }), reduceMotion.matches ? 0 : 60);
  }

  function close(sheet, restoreFocus = true) {
    sheet.classList.remove("is-open");
    const panel = sheet.querySelector("[data-sheet-panel]");
    panel.style.transform = "";
    document.querySelectorAll(`[aria-controls="${sheet.id}"]`).forEach(b => b.setAttribute("aria-expanded", "false"));
    const done = () => { if (!sheet.classList.contains("is-open")) sheet.hidden = true; };
    reduceMotion.matches ? done() : setTimeout(done, 380);
    if (openSheet === sheet) openSheet = null;
    if (!openSheet) document.documentElement.classList.remove("is-sheet-open");
    if (restoreFocus) lastTrigger?.focus({ preventScroll: true });
  }

  document.querySelectorAll("[data-sheet-open]").forEach(btn => {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", () => { const s = document.getElementById(btn.dataset.sheetOpen); if (s) open(s, btn); });
  });

  document.querySelectorAll("[data-sheet]").forEach(sheet => {
    sheet.querySelectorAll("[data-sheet-close]").forEach(el => el.addEventListener("click", () => close(sheet)));

    // Keep Tab / Shift+Tab inside the open sheet; Escape closes it.
    sheet.addEventListener("keydown", e => {
      if (e.key === "Escape") { e.preventDefault(); close(sheet); return; }
      if (e.key !== "Tab") return;
      const items = [...sheet.querySelector("[data-sheet-panel]").querySelectorAll(FOCUSABLE)].filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Swipe down on the sheet's header to dismiss (bottom-sheet layout only).
    const panel = sheet.querySelector("[data-sheet-panel]");
    const handle = sheet.querySelector("[data-sheet-drag]");
    const mobile = matchMedia("(max-width: 989.98px)");
    let startY = null, dy = 0;
    handle?.addEventListener("touchstart", e => { if (!mobile.matches) return; startY = e.touches[0].clientY; dy = 0; panel.style.transition = "none"; }, { passive: true });
    handle?.addEventListener("touchmove", e => {
      if (startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = `translateY(${dy}px)`;
    }, { passive: true });
    handle?.addEventListener("touchend", () => {
      if (startY === null) return;
      panel.style.transition = "";
      startY = null;
      if (dy > 90) close(sheet); else panel.style.transform = "";
    });
  });

  window.IZUSheet = { open, close };
})();
